import React from 'react';

import DeleteModal from './delete-modal'

import 'react-loading-skeleton/dist/skeleton.css'

const OrganisationInformation = ({ organisation }) => {
  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark mb-4 border-red-600 mt-12">

      <div className="border-b border-stroke pl-4 py-1 dark:border-strokedark bg-red-500 text-white">
        <div className="text-right float-right text-sm bg-white text-red-600 py-[9px] px-2 font-bold -mt-[5.5px]">
          <strong>God Mode</strong>
        </div>
        <h3 className="font-medium text-xl dark:text-white text-purple-900">
          Archive <strong>Organisation</strong>
        </h3>
      </div>

      <div className="clearfix p-4 h-auto">
        <div className="text-gray-700 font-bold float-right">
          <DeleteModal organisation={organisation} />
        </div>
        <p className='text-red-600 text-md pt-1'>This action will <strong>archive the merchant account, remove all API access and prevent users from logging into the Dashboard!</strong></p>
      </div>
    </div>
  );
}

export default OrganisationInformation;